import { render } from "./AHJTableResultInfo.vue?vue&type=template&id=53519c2b&scoped=true"
import script from "./AHJTableResultInfo.vue?vue&type=script&lang=js"
export * from "./AHJTableResultInfo.vue?vue&type=script&lang=js"

import "./AHJTableResultInfo.vue?vue&type=style&index=0&id=53519c2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53519c2b"]])

export default __exports__